// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"856ec068","516":"9adf600b","600":"9bd0688e"}[chunkId] + ".chunk.js";
};